<template>
  <div>
    <div v-if="type == 1">
      <div
        v-for="(item, index) in articleList"
        :key="index"
        @click="detailsOne(item)"
      >
        <div class="articleItem">
          <div class="itemTit">
            <span></span>
            <div>{{ item.title }}</div>
          </div>
          <div class="itemTime">{{ item.inputtime }}</div>
        </div>
        <div class="xuxian"></div>
      </div>
    </div>

    <div v-if="type == 2" class="outerBox">
      <div
        class="outstanding"
        v-for="(item, index) in articleList"
        :key="index"
        @click="details(item)"
      >
        <img :src="item.thumb" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>

    <div v-if="type == 3" class="writtenWordsBox">
      <div
        class="writtenWord"
        v-for="(item, index) in articleList"
        :key="index"
        @click="details(item)"
      >
        <div>{{ item.title }}</div>
      </div>
    </div>

    <el-pagination
      :currentPage="currentPage"
      :page-size="pageSize"
      background
      layout="prev, pager, next, jumper"
      :total="total"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      style="margin-top: 41px; padding: 0 88px"
    />

    <articleDetails :articleInfo="articleInfo"></articleDetails>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：文章列表
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-04-14 09:09
 */
import articleDetails from "@/views/articleDetails.vue"; // 文章详情
export default {
  components: { articleDetails },
  props: [
    "currentPage", //这样可以指定传入的类型，如果类型不对，会警告
    "pageSize",
    "total",
    "articleList",
    "type", // 1:文章列表  2:图文  3:文字
  ],
  data() {
    return {
      articleInfo: "",
    };
  },
  mounted() {
    // console.log(this.currentPage);
  },
  methods: {
    // 分页上一页下一页
    handleCurrentChange(val) {
      console.log(`current page: ${val}`);
      //当点击子组件的按钮的时候，如何拿到父组件传递过来的func方法，并调用这个方法
      //英文愿意：是触发，调用、发射的意思
      this.$emit("func", val);
    },

    // 跳转详情
    details(item) {
      console.log(item)
      this.$emit("personnelDetails", item);
    },

    detailsOne(item){
      this.$parent.articleDetails(item)
    },
  },
};
</script>
<style lang='scss' scoped>
.articleItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 12px;
  cursor: pointer;
  .itemTit {
    width: 80%;
    display: flex;
    align-items: center;
    span {
      width: 6px;
      height: 6px;
      background: #045ba7;
      border-radius: 50%;
      margin-right: 12px;
    }
    div {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
  }
  .itemTime {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #aaaaaa;
  }
}

.xuxian {
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    #cccccc 0%,
    #cccccc 50%,
    transparent 50%
  );
  background-size: 19px 1px;
  background-repeat: repeat-x;
}

.outerBox {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 10px 0;
  margin-bottom: -30px;
  .outstanding {
    width: 160px;
    margin-right: 74px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 30px;
    cursor: pointer;
    img {
      width: 160px;
      height: 160px;
    }
    > div {
      padding: 13px 0;
      text-align: center;
      width: 100%;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
      background: #f2f2f2;
    }
  }

  .outstanding:nth-child(4n) {
    margin-right: 0 !important;
  }
}

.writtenWordsBox {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 10px 0;
  margin-bottom: -30px;
  .writtenWord {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
    margin-right: 40px;
    cursor: pointer;
    > div {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
    }
  }
}
</style>